import AreaCascader from '@/components/request/elements/AreaCascader/AreaCascader.vue';
import { mapActions } from 'vuex';

export default {
    name: 'TicketReclassifyDialog',

    components: { AreaCascader },

    props: {
        value: { type: Boolean, required: true },
        item: { type: Object, required: true },
    },

    data() {
        return {
            newSubtype: null,
            dialogKey: 0,
            reclassifyTicketLoading: false,
        }
    },

    computed: {
        isOpen: {
            get() { return this.value },
            set(val) { this.$emit('input', val) },
        },
    },

    methods: {
        ...mapActions('ticket', ['reclassifyTicket']),

        handleClose() {
            this.isOpen = false;
            this.newSubtype = null;
            this.dialogKey++;
        },

        async handleSubmit() {
            if (!this.newSubtype || this.newSubtype.children?.length > 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Subtipo incompleto',
                    text: 'Debes seleccionar el último subtipo disponible.',
                    confirmButtonColor: '#0039a6',
                });
                return;
            }

            const { id: ticketId } = this.item;
            const assigned_user_id = this.item.assigned_user_id;
            const subtypeId = this.newSubtype.id;

            this.reclassifyTicketLoading = true;

            try {
                const { ok, error } = await this.reclassifyTicket({ ticketId, subtypeId, assigned_user_id });

                if (ok) {
                    this.$swal({
                        icon: 'success',
                        title: 'Reclasificación exitosa',
                        confirmButtonColor: '#0039a6',
                    });

                    this.isOpen = false;
                    this.newSubtype = null;
                    this.dialogKey++;
                    this.$emit('refresh');

                } else {
                    this.$swal({
                        icon: 'error',
                        title: 'Error',
                        text: error?.data?.message || 'No se pudo reclasificar el ticket.',
                        confirmButtonColor: '#0039a6',
                    });
                }
            } catch (err) {
                this.$swal({
                    icon: 'error',
                    title: 'Error inesperado',
                    text: err?.message || 'Algo salió mal al reclasificar el ticket.',
                    confirmButtonColor: '#0039a6',
                });
            } finally {
                this.reclassifyTicketLoading = false;
            }
        }
    },
}